// extracted by mini-css-extract-plugin
export default {"visibleOnMobileLayout":"ModalInMobileExample_visibleOnMobileLayout__JBhtC"};